import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Page } from '../../classes/page';
import { Account } from '../../constants/account.enum';
import { UtilityServiceService } from '../../services/utility-service.service';
import { PopupService } from '../../services/shared/popup.service';
import { CompanydetailsComponent } from '../../companydetails/companydetails.component';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogService } from '../../services/shared/confirm-dialog/confirm-dialog.service';
import { UploaddocumentComponent } from '../../uploaddocument/uploaddocument.component';

declare var $: any;

@Component({
  selector: 'ca-management',
  templateUrl: './management.component.html',
  styleUrls: ['./management.component.css']
})
export class ManagementComponent implements OnInit {

  sub: any;
  acc = Account;
  iconCtrl = 1;
  displayFlag:boolean=false;
  status: any;
  @Input('ctrlData') ctrlData: any;
  switchCtrl: number;
  //ctrlData: any = { carrierId: 0, isApproval: false, currentActive: 1, action: 0, ctrlAction: 0, data: {} };
  @ViewChild(CompanydetailsComponent) company: CompanydetailsComponent;

  @ViewChild(UploaddocumentComponent) document: UploaddocumentComponent;

  constructor(private router: Router, private route: ActivatedRoute,
     private msgService: PopupService, public utility: UtilityServiceService,
      private msg: ToastrService,private confirmDialogService: ConfirmDialogService) { }

  ngOnInit() {
    if (!this.ctrlData) {
      this.ctrlData = { carrierId: 0, isApproval: false, currentActive: 1, action: 0, ctrlAction: 0, xstatus:0, data: {} };  
     
     
      this.route.paramMap.subscribe((params: Params) => {
     
      
        if(params['status']!=""){
          this.status = params.get("status");
          if(this.status == 1)
          {
            this.utility.isProcessAccounts = false;
            this.ctrlData.isApproval = true;
            this.ctrlData.carrierId = params.get("id");
            this.ctrlData.xstatus = 1;
          }
          else  if(this.status == 2)
          {
            this.ctrlData.isApproval = true;
            this.utility.isProcessAccounts = true;
            this.ctrlData.carrierId = params.get("id");
            this.ctrlData.xstatus = 1;
          }
        }

       
      })
    
    }   
    this.preprocessing();
  }
  ngAfterViewInit() {
  }

  preprocessing = () => {
    if (this.ctrlData.isApproval) {
      this.utility.activeTab = 3;
      this.utility.ctrlPages[Account.First].carrierId = this.ctrlData.carrierId;
      this.utility.ctrlPages[Account.First].isEdit = true;
      this.utility.docCtrl = true;
      this.utility.confirmCtrl = true;
      
    } else {
      //this.utility.isView = false;
      this.utility.activeTab = 1;
      this.utility.isBtnVisible = true;
      this.sub = this.route.params.subscribe(params => {
        this.utility.switchOnVisibility(Account.First);
        this.utility.ctrlPages[Account.First].carrierId = +params['id'];
        if (this.router.url.indexOf('edit') != -1) {
          this.utility.ctrlPages[Account.First].isEdit = true;
          this.utility.docCtrl = true;
          this.utility.confirmCtrl = true;
        } else {
          this.utility.ctrlPages[Account.First].isEdit = false;
          this.utility.docCtrl = false;
          this.utility.confirmCtrl = false;
        }
      });
    }

  }

  onActive = (key = 1) => {
    if(key === 3){
      if(this.document === undefined){
        return this.msg.warning('Please verify the documents first before comfirming your details!');
      }
      for(let i = 0;i<this.document.DocTypesList.length;i++){
        if(this.document.DocTypesList[i].is_mandatory){
          return this.msg.warning(this.document.DocTypesList[i].description + ' is required');
        }
      }
    }
    this.iconCtrl = key;
    this.switchCtrl = key;
    this.toogle();

  }

  nextFrame = () => {
    let isEd = (this.utility.ctrlPages[Account.First].carrierId > 0) ? true : false;
    /*
    if (isEd) {
      this.msgService.showYesNo('Save & Continue', 'Please note that the account change will need to be re-submitted for approval, do you want to continue?', '', 'Yes', 'No')
        .subscribe((isConfirmed) => {
          if (isConfirmed) {
            this.nextFrameDeleg();
          } else {
            this.utility.landingPage();
          }
        });
    }
    else {
      this.nextFrameDeleg();
    }
    */
    this.nextFrameDeleg();
  }
  back(){
    this.utility.activeTab = 1;
  }
  nextFrameDeleg() {
    var self = this;
    var count = 0;
    $(document).ready(function() {
     
      if ($('.file-upload').length > 0) {
        $('.file-upload').each(function(){          
          var id = this.id;         
          if ($('#' + id).val() == '' || $('#' + id).val()==undefined) {
            var docDescId = id + "-desc";
            var documentName = $('#' + docDescId).val();
            self.msg.warning(documentName + ' is required!');
            return false;
          }
          if ($('.file-upload').length - 1 == count) {
            self.utility.activeTab = 3;
            self.utility.confirmCtrl = true;
            self.iconCtrl = 3;
          }
          count++;
        });
      } else {
        self.utility.activeTab = 3;
        self.utility.confirmCtrl = true;
        self.iconCtrl = 3;
      }
    });
  }
  toogle = (key = 1) => {
    if (this.utility.isChanged) {
      // this.msgService.showYesNo('Unsaved Changes Detected', 'You have unsaved data. Do you wish to save your data?', 'Unsaved data will be lost.').subscribe(isConfirmed => {
      //   if (isConfirmed) {
      //     if (this.company)
      //       this.company.autoSave(this.switchCtrl);
      //   } else {
      //     this.utility.isChanged = false;
      //     this.utility.activeTab = this.switchCtrl;
      //   }
      //   if (this.switchCtrl == 2) {
      //     //this.utility.activeTab = this.switchCtrl;
      //     $('.nav-tabs a:eq(1)').tab('show');
      //     //this.utility.isChanged = false;
      //     //else {           
      //     //  $('.nav-tabs a:eq(0)').tab('show');
      //     //}
      //   } else if (this.switchCtrl == 3) {
      //     //this.utility.activeTab = this.switchCtrl;
      //     $('.nav-tabs a:eq(2)').tab('show');
      //     //this.utility.isChanged = false;
      //   }
      // })
      this.confirmDialogService.confirmThis("You have unsaved data. Do you wish to save your data?", () => {  
          
        if (this.company)
          this.company.autoSave(this.switchCtrl);

          if (this.switchCtrl == 2) {
            //this.utility.activeTab = this.switchCtrl;
            $('.nav-tabs a:eq(1)').tab('show');
            //this.utility.isChanged = false;
            //else {           
            //  $('.nav-tabs a:eq(0)').tab('show');
            //}
          } else if (this.switchCtrl == 3) {
            //this.utility.activeTab = this.switchCtrl;
            $('.nav-tabs a:eq(2)').tab('show');
            //this.utility.isChanged = false;
          }
      
      }, () =>  {  
        this.utility.isChanged = false;
          this.utility.activeTab = this.switchCtrl;
          
      })
    } else {
      this.utility.activeTab = this.switchCtrl;
    }
  }


}
